import React from "react";
import { makeStyles } from "@material-ui/styles";
import PropTypes from 'prop-types';
import PatientAddForm from "./PatientAddForm";

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
  content: {
    marginTop: theme.spacing(2),
  },
}));


const PatientAdd = (props) => {

  const {className, history, ...rest } = props;
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <div className={classes.content}>
        <PatientAddForm history={history} />
      </div>
    </div>
  );
};

PatientAdd.propTypes = {
  history: PropTypes.object
};

export default PatientAdd;
